import React from 'react';
import DashboardMainContainer from '../../../../components/common/Containers/DashboardMainContainer';
import {
  AdminPanelTitle,
  AdminDetailFieldLabel,
  ADMIN_FORM_PANEL_CLASS,
} from '../../shared/adminUx';

const ConfigurationRuleTestResultPanel = ({ testResult }) => {
  if (!testResult) return null;

  return (
    <DashboardMainContainer className={ADMIN_FORM_PANEL_CLASS}>
      <div className="space-y-4">
        <AdminPanelTitle className="text-offblack mb-2">Rule Test Result</AdminPanelTitle>
        <p
          className={`text-sm font-medium ${
            testResult.testStatus === 'Pass' ? 'text-freshgreen' : 'text-alertred'
          }`}
        >
          Simulation test: {testResult.testStatus}
        </p>
        {testResult.testStatus === 'Fail' && testResult.failReasons?.length ? (
          <div className="space-y-2">
            <AdminDetailFieldLabel>Reason to Fail</AdminDetailFieldLabel>
            <ul className="text-sm text-alertred space-y-1 list-disc pl-5">
              {testResult.failReasons.map((reason) => (
                <li key={reason}>{reason}</li>
              ))}
            </ul>
          </div>
        ) : null}
        <p className="text-sm text-offblack">Message Shown: {testResult.messageShown}</p>
        <p className="text-sm text-offblack">
          Expected and Actual Match: {testResult.expectedAndActualMatch}
        </p>
      </div>
    </DashboardMainContainer>
  );
};

export default ConfigurationRuleTestResultPanel;
